import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'upperCropped'
  })
  export class UpperCropped implements PipeTransform {
    transform(value: string, len: number = 23): string {
      return (value.length > len ? value.substr(0, len) + "..." : value).toUpperCase();
    }
  }